import { Helmet } from "react-helmet-async";

/**
 * Central per-page meta tag helper.
 * Pass a canonical `path` (starting with `/`); we build absolute canonical URLs
 * from window.location.origin so the sitemap and page canonicals agree.
 */
export default function Seo({
  title,
  description,
  path,
  robots,
  jsonLd,
}) {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  const canonical = path ? `${origin}${path}` : undefined;
  const fullTitle = title ? `${title} — Surfmatics` : "Surfmatics — Find your best surf";
  const desc =
    description ||
    "Personalised surf intelligence for beginner and intermediate surfers. Live forecasts, tides, wind and community reports — combined into a single suitability score.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {robots ? <meta name="robots" content={robots} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
